import DataTable from "frappe-datatable";
// import DataTable from "../views/reports/tabulator";

frappe.DataTable = DataTable;
